export const Dimensions = {
    Heights: {
        inputHeight: "2.625rem"
    },
};